import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import CategoryView from '../components/version-4/viewForms/CategoryView'
import { useCategory } from '../hooks/Features/useCategory'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewCategory() {
  const { getCategory, category } = useCategory()
  const params = useParams()

  React.useEffect(() => {
    getCategory({ categoryId: params.categoryId })
  }, [params.categoryId])

  return (
    <Layout heading="Category" heading2="Info" url1={ROUTES.CATEGORIES} none>
      {category ? (
        <HeaderTabLayout
          heading="Category"
          content={<CategoryView category={category} />}
          view
          url={`/edit-category/${params.categoryId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}

export default ViewCategory
